import { LoaderSmallStyled, LoaderWrapper } from './style';

interface LoaderSmallProps {
  ac?: boolean;
  size?: number;
}

const LoaderSmall = ({ ac, size = 30 }: LoaderSmallProps) => (
  <LoaderWrapper ac={ac}>
    <LoaderSmallStyled style={{ width: `${size}px`, height: `${size}px` }} />
  </LoaderWrapper>
);

export { LoaderSmall };
